<template>
  <!--우편번호 팝업 -->
  <v-dialog v-model="postPop" max-width="500" persistent>
    <v-card class="address-popup">
      <div class="text-right">
        <v-btn @click="$emit('close')" text>X</v-btn>
      </div>
      <vue-daum-postcode
        style="height:500px;"
        @complete="searchPost"
        :key="componentKey"
        ref="postPopup"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { VueDaumPostcode } from "vue-daum-postcode";

export default {
  components: {
    VueDaumPostcode,
  },
  data() {
    return {
      // address popup
      postResult: {},
      postPop: true,
      componentKey: 0,
    };
  },
  methods: {
    searchPost(event) {
      this.postResult = event;
      this.postPop = false;

      this.$emit("postNewData", event);
    },
  },
};
</script>

<style></style>
